import { v4 as uuid } from 'uuid'

export interface IQuickbooksExport {
  id: string
  orderIds: string[]
  exportedDate?: Date
  exportedByUserId: string
  exportedByCompanyId: string
}

export class QuickbooksExport implements IQuickbooksExport {
  public id: string
  public orderIds: string[] = []
  public exportedDate?: Date

  constructor(
    public exportedByUserId: string,
    public exportedByCompanyId: string
  ) {
    this.id = uuid()
  }
}
